import {
  AnyAppEvent,
  AppEventName,
  ApolloClient,
  ClientMetrics,
  EventTracker,
  Log,
  LogLevel,
  TrackerCategory
} from '@sfstudios/shapeshifter';
import { apolloLog } from '../apolloLog';

const SPLUNK_EVENT_LEVELS: Partial<Record<AppEventName, LogLevel>> = {
  'buyButton.clicked': LogLevel.info,
  'checkout.transactionPaidForFirstTime': LogLevel.info,
  'favorites.added': LogLevel.info,
  'list.itemClicked': LogLevel.info,
  'notification.requested': LogLevel.info,
  'pagination.loadMore': LogLevel.info,
  'playButton.clicked': LogLevel.info,
  'player.clickNextEpisodeButton': LogLevel.info,
  'player.clickSkipIntroButton': LogLevel.info,
  'player.showNextEpisodeButton': LogLevel.info,
  'player.showSkipIntroButton': LogLevel.info,
  'qr.urlSuccess': LogLevel.info,
  'search.filterChanged': LogLevel.info,
  'search.removed': LogLevel.info,
  'search.reset': LogLevel.info,
  'search.saved': LogLevel.info,
  'search.shortcutUsed': LogLevel.info,
  'session.loggedIn': LogLevel.info,
  'takeover.infoClick': LogLevel.info,
  'qr.urlError': LogLevel.error,
  'remoteAuth.error': LogLevel.error
};

const splunkTracker = (client: ApolloClient): EventTracker => {
  const cMetrics = new ClientMetrics({
    logFunc: (logs) => apolloLog(client, logs as Log[])
  });

  return {
    id: 'splunkTracker',
    category: TrackerCategory.Required,
    onEvent: (event: AnyAppEvent) => {
      const level = SPLUNK_EVENT_LEVELS[event.type];
      if (!level) return;

      cMetrics.log({
        evt: event.type,
        ...((event.payload ?? {}) as Record<string, unknown>),
        level
      });
    }
  };
};

export default splunkTracker;
